export default {"src":"/_next/static/media/management.15ed8ac1.svg","height":22,"width":22};